import React from 'react'

export default function PageTitle({pageTitle}) {
  return (
    <div className="text-2xl font-bold mb-4 text-center text-orange-300">{pageTitle}</div>
  )
}

